import React from 'react';
import { vars } from '../../../Theme';
import { mdiAlertCircle, mdiCheckCircle } from '@mdi/js';
import AppTooltip from '../AppTooltip/AppTooltip';
import Icon from '@mdi/react';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (props: any) => {
    const { row } = props;
    const { t } = useTranslation('translations', { keyPrefix: 'importTableStatusCell' });

    const validation = (row['Validation'] ?? []) as string[];

    const errorIcon = (
        <AppTooltip title={validation.map(msg => t(msg)).join('\n')}>
            <Icon path={mdiAlertCircle} size={1} color={vars.errorRed} />
        </AppTooltip>
    );

    const validIcon = <Icon path={mdiCheckCircle} size={1} color={vars.brandGreen} />;

    return validation.length ? errorIcon : validIcon;
};
